export default __webpack_public_path__ + "static/media/background_kingdom.fb92fe8a.jpg";